import { Box, Stack, useTheme } from "@mui/material";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { TEvent } from "src/shared/types/globalStotre.types";

export function EventTags(props: { event: TEvent }) {
  const theme = useSSTheme();
  const muiTheme = useTheme();

  if (props?.event?.tagsArray?.length === 0) return null;
  return props?.event?.tagsArray?.map((itm, idx) => {
    return (
      <Box
        key={idx}
        sx={{
          backgroundColor: theme.colors.teamSecondary,
          color: muiTheme.palette.getContrastText(theme.colors.teamSecondary),
          fontSize: "0.8rem",
          fontWeight: 600,
          padding: "0.2rem 0.5rem",
          borderRadius: "0.5rem",
        }}
      >
        {itm}
      </Box>
    );
  });
}
